var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.75 25.89a9.82 9.82 0 0 0-8.08-15.42 10.25 10.25 0 0 0-7.21 3.46.58.58 0 0 1-.84 0 10.16 10.16 0 0 0-7.29-3.46A9.84 9.84 0 0 0 7.5 20.3c0 3.13 1.5 5.48 3.76 7.7l10.65 10.68a3 3 0 0 0 2.06.85h2.13a3 3 0 0 0 2.07-.85s11.48-11.2 12.58-12.79M26.07 37.47a1.45 1.45 0 0 1-2.06 0L12.15 25.73a7.5 7.5 0 0 1 5.18-12.94c4.11 0 6.68 4.08 6.7 4.11a1.17 1.17 0 0 0 2 0s2.72-4.14 6.67-4.14a7.5 7.5 0 0 1 5.75 12.33z"
  })));
};
export default SvgHeart;